export const parsePengirimanText = (text) => {
    const result = {};

    const patterns = {
        namaPengirim: /Nama\s*Pengirim\s*:\s*(.+)/i,
        noTeleponPengirim: /Nomor\s*WA\s*Pengirim\s*:\s*(.+)/i,
        tujuanNegara: /Diteruskan\s*ke\s*:\s*(.+)/i,
        tujuanKota: /Tujuan\s*di\s*Negara\s*:\s*(.+)/i,
        alamatPenerima: /Alamat\s*Luar\s*Negeri\s*:\s*(.+)/i,
        namaPenerima: /Nama\s*:\s*(.+)/i,
        noTeleponPenerima: /No\s*hp\s*:\s*(.+)/i,
        jumlahBarang: /Berat\s*paket\s*:\s*(.+)/i,
        namaBarang: /Isi\s*paket\s*:\s*(.+)/i,
    };

    Object.keys(patterns).forEach((key) => {
        const match = text.match(patterns[key]);
        if (match && match[1]) {
            result[key] = match[1].trim();
        }
    });

    return result;
};